import logo from "@/assets/images/creator-shield-full-logo.png";
import ceoSignature from "@/assets/images/sgntr.png";
import jsPDF from "jspdf";

const highlightText = (
  doc,
  text,
  x,
  y,
  highlightColor = [255, 255, 0],
  paddingX = 1,
  paddingY = 0
) => {
  doc.setFillColor(...highlightColor);

  const textWidth = doc.getTextWidth(text);
  const textHeight = doc.internal.getFontSize();

  doc.rect(
    x - textWidth / 2 - paddingX,
    y - textHeight / 2 - paddingY,
    textWidth + 2 * paddingX,
    textHeight + 2 * paddingY,
    "F"
  );

  doc.setTextColor(0, 0, 0);
  doc.text(text, x, y, { align: "center" });
};

const platformNames = {
  youtube: "YouTube",
  facebook: "Facebook",
  instagram: "Instagram",
  bilibili: "Bilibili",
  tiktok: "TikTok",
  snapchatStars: "Snapchat Stars",
};

export const creatorshieldContract = (user, ipAddress, signature) => {
  const doc = new jsPDF();

  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();

  doc.setFontSize(18);
  doc.setFont("Helvetica", "bold");

  doc.addImage(logo, "PNG", 78, 13, 50, 13);

  doc.setFontSize(16);
  doc.text("Terms of Service", doc.internal.pageSize.getWidth() / 2, 40, {
    align: "center",
  });

  doc.setFontSize(16);
  doc.text(
    "Global content protection and monetization agreement",
    doc.internal.pageSize.getWidth() / 2,
    50,
    { align: "center" }
  );

  doc.setFontSize(16);
  doc.text(
    "",
    doc.internal.pageSize.getWidth() / 2,
    57,
    { align: "center" }
  );


  doc.setFontSize(13);
  doc.setFont("Helvetica", "normal");
  const text = `CreatorShield User Agreement, herein referred to as the (“Agreement”) which is by and between CreatorShield FZCO (“CreatorShield FZCO”, “we”) doing business as “CreatorShield” and the undersigned producer/content owner (“Producer”, “you”, “your”) ${user.firstName} ${user.lastName},who is registering to the service, and has agreed to the terms of this User Agreement, effective as of today\'s date ${currentDate}. This is the effective date(“Effective Date”).`;
  doc.text(text, 15, 65, { maxWidth: 180 });

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 1. Scope
  doc.text("1. Scope", doc.internal.pageSize.getWidth() / 15, 103);

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1. The purpose of this Agreement is to grant exclusive, non-transferable, irrevocable Content Licensing rights to CreatorShield (CreatorShield FZCO) in order to legally perform its services and comply with the policies in place that moderate CreatorShield and its use of sensitive third-party tools, including but not limited to: YouTube Content ID, Facebook Rights Manager, SnapChat Discovery, Microsoft feeds. You acknowledge that without these rights, it is impossible for us to legally perform our service. Our service in this instance is to protect and monetize your catalog of content through a combination of publishing and royalty claiming techniques on various third-party platforms.",
    doc.internal.pageSize.getWidth() / 15,
    114,
    { maxWidth: 180 }
  );

  doc.text(
    "2.  You still retain ownership of all your content, videos, and intellectual property. However, upon registration submission, you forfeit all rights to licensing the content submitted to other companies in the future and CreatorShield FZCO will uphold its right as the exclusive license holder in order to comply with usage guidelines policies mandated to us by third-party platforms; otherwise, this service is impossible to perform.",
    doc.internal.pageSize.getWidth() / 15,
    159,
    { maxWidth: 180 }
  );

  doc.text(
    "3.  By agreeing to the terms set forth, you are allowing CreatorShield FZCO to exclusively manage and monetize your video content internally and externally without limitation.",
    doc.internal.pageSize.getWidth() / 15,
    190,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 2. Content for Licensing
  doc.text(
    "2. Content for Licensing",
    doc.internal.pageSize.getWidth() / 15, 207
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1.  The “Content” means the content produced and posted to your social media channels that are being submitted upon registration and submission (examples include YouTube, Instagram, TikTok, Facebook, Douyin, Kuaishou, etc.), as well as any other content that we and you agree in writing to include in this Agreement from time to time.",
    doc.internal.pageSize.getWidth() / 15,
    219,
    { maxWidth: 180 }
  );

  doc.text(
    "2.  You may deliver additional content to your point person at CreatorShield FZCO or by writing to copyright@CreatorShield FZCO.com and attaching the content you desire to submit as a file or via cloud storage with your provider of choice, e.g. DropBox, OneDrive, etc.",
    doc.internal.pageSize.getWidth() / 15,
    245,
    { maxWidth: 180 }
  );

  doc.text(
    "3.  At the time of this Agreement, the social video content has been submitted by you to CreatorShield FZCO for exclusive, non-transferable, irrevocable content management services; including but not limited to digital rights management on YouTube and other platforms.",
    doc.internal.pageSize.getWidth() / 15,
    267,
    { maxWidth: 180 }
  );

  doc.addPage();

  doc.text(
    "4. All content on the pages set forth on the onboarding registration submission form has been submitted to CreatorShield FZCO for exclusive, non-transferrable, irrevocable licensing and will be subject to review for its usage within CreatorShield FZCO and its Network.",
    doc.internal.pageSize.getWidth() / 15,
    25,
    { maxWidth: 180 }
  );

  doc.text(
    "Please note that not all content may be eligible, and that CreatorShield FZCO’s team will review the submitted content herein to ensure third-party platform compliance.",
    doc.internal.pageSize.getWidth() / 15,
    47,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 3. Fees and Payments
  doc.text(
    "3. Fees and Payments",
    doc.internal.pageSize.getWidth() / 15, 64
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1. For the first one hundred USD generated in a given month, CreatorShield FZCO will deduct a free services fee equal to this amount because of its decision to absorb all of the cost, labour, and risk in allowing you to freely register to its services. Afterward, along with five percent of the revenues generated as a content hosting fee (at the moment, Dropbox Premium), CreatorShield FZCO will automatically split the recouped revenue with the Producer in accordance to the revenue-sharing rates of this agreement which are subject to change from time-to-time as per the Company's discretion and market conditions. For YouTube partner ad-revenues generated by YouTube's algorithmic claiming, the baseline revenue-sharing tier after any applicable service or administration fee is half to you and half to CreatorShield FZCO, along with an additional five percent to you (which is SEPARATE TO THE EXISTING share) if your content is selected, at our sole and absolute discretion, for ANY SPECIAL promotional or anchor campaign on our supported platforms, which may change from time to time.",
    doc.internal.pageSize.getWidth() / 15,
    75,
    { maxWidth: 180 }
  );

  doc.text(
    "2.  Payments are sent out within 30-days of revenue generation and payment made to us. For example, if you generate revenue in January, you will receive your share at the end of February.",
    doc.internal.pageSize.getWidth() / 15,
    140,
    { maxWidth: 180 }
  );

  doc.text(
    "3.  You will be responsible for taxes and reporting your revenues in your own respective country, and CreatorShield FZCO will not be held liable in any way in the event you neglect your duties to report whatever ought to be reported.",
    doc.internal.pageSize.getWidth() / 15,
    160,
    { maxWidth: 180 }
  );

  doc.text(
    "4.  In the event that ads are displayed on other channels containing copyrighted content from multiple claimants, you will be entitled to collect a share of the divided revenue with other rights holders (e.g. Music Publishers) after appropriate splits have taken place.",
    doc.internal.pageSize.getWidth() / 15,
    180,
    { maxWidth: 180 }
  );

  doc.text(
    "5.  CreatorShield FZCO is not obligated to pay you for any re-uploaded videos that fall outside of YouTube's content delivery requirements and criteria policies, including content that falls below YouTube's required minimum lengths for ALGORITHMIC claiming.",
    doc.internal.pageSize.getWidth() / 15,
    200,
    { maxWidth: 180 }
  );

  doc.text(
    "6.  The Network ('CreatorShield FZCO') will have no obligation to pay any amounts, and is permitted to deduct or withhold any amounts owed, determined or reasonably suspected by CreatorShield FZCO, in its sole discretion, to have resulted from: (a) Action Fraud, including without limitation through any clicks originating from Talent's IP addresses or computers under Talent's control, solicited by payment of money, false representation or request for end users to click on Ads, or (b) fraudulent, misleading or false activities or activities that CreatorShield FZCO or its primary platforms, which is YouTube and Facebook, believe to be fraudulent or misleading or in violation of either of their respective terms of service, guidelines, rules, or privacy policies.",
    doc.internal.pageSize.getWidth() / 15,
    221,
    { maxWidth: 180 }
  );

  doc.text(
    "7.  The Network ('CreatorShield FZCO') reserves the right to withhold or deduct any payments, pending CreatorShield FZCO's reasonable investigation of any of the foregoing or any breach of this Agreement.",
    doc.internal.pageSize.getWidth() / 15,
    267,
    { maxWidth: 180 }
  );

  doc.addPage();

  doc.text(
    "8.  Conflict resolution fees will be charged when CreatorShield FZCO argues and handles a disputed asset resolution on your behalf if you attempt to work with multiple content claiming providers at once, thus causing extra administrative work for CreatorShield FZCO. If in any given month there is one or more of these events, you will be charged an additional five percent of the partner ad-revenue generated in that given month.",
    doc.internal.pageSize.getWidth() / 15,
    25,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 4. Contract Period
  doc.text(
    "4. Contract Period",
    doc.internal.pageSize.getWidth() / 15, 55
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1.  The period of this Agreement will be for 12-months with automatic renewals thereafter, unless you terminate this Agreement with 90-days written notice prior to the renewal date in form of legal writing to copyright@CreatorShield FZCO.com",
    doc.internal.pageSize.getWidth() / 15,
    65,
    { maxWidth: 180 }
  );

  doc.text(
    "2.  Should you decide to end this Agreement, we agree to stop uploading/monetizing any new content you upload after the termination date. You acknowledge and understand that previously activated reference files will remain exclusively licensed to us, as required by the third-party platforms we partner with making it possible to provide this service in the first place.",
    doc.internal.pageSize.getWidth() / 15,
    85,
    { maxWidth: 180 }
  );

  doc.text(
    "3. If you choose to terminate this Agreement, we will ensure your final payment is processed within 30 days of termination. By ending your Agreement with CreatorShield FZCO/ CreatorShield, or any of our affiliates, you agree that no further payments will be made to you after the termination date.",
    doc.internal.pageSize.getWidth() / 15,
    110,
    { maxWidth: 180 }
  );

  doc.text(
    "4. The content, video assets, and I.P. that you created, published, and/or generated prior to, and during the tenure of your Partnership with the Company will remain active and CreatorShield FZCO’s exclusive content license will remain nontransferable and active within its Content Management Systems, including but not limited to publishing and protection on YouTube, Facebook, Microsoft, and Snapchat discovery. The exclusive license will survive the termination of this Agreement and will remain non-transferable for all content submitted upon registration and submission.",
    doc.internal.pageSize.getWidth() / 15,
    136,
    { maxWidth: 180 }
  );

  doc.text(
    "5.CreatorShield FZCO will retain its exclusive, nontransferable content license rights after termination for all content submitted prior to the effective date of your termination. If you decide to work with another content claiming Company, CreatorShield FZCO will keep its right to manage the content internally and externally within its systems, including but not limited to: Content ID, Rights Manager, MS FEEDS, and tools of this nature.",
    doc.internal.pageSize.getWidth() / 15,
    176,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 5. CreatorShield FZCO’s Rights and Licenses
  doc.text(
    "5. CreatorShield FZCO’s Rights and Licenses",
    doc.internal.pageSize.getWidth() / 15, 207
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "You hereby grant to each of the following exclusive and non-transferable rights:",
    doc.internal.pageSize.getWidth() / 15,
    218,
    { maxWidth: 180 }
  );

  doc.text(
    "1. The exclusive right and license to use, reproduce, digitize, encode, modify, monetize, re-format, transmit, re-broadcast, repurpose the Content and collect revenues from the protection, publishing, and management of the Content on YouTube, Facebook, Snapchat, TikTok, Microsoft, and others from time to time. You will be paid your share of the partner ad-revenue on a monthly basis for as long as this Agreement is active.",
    doc.internal.pageSize.getWidth() / 15,
    228,
    { maxWidth: 180 }
  );

  doc.text(
    "2. The exclusive right and license to administer content claiming, including without limitation, Content ID claims, and monetization services for the Content across third-party platforms. If you have no existing presence on a promotional platform (i.e. Snapchat, Microsoft, Facebook, YouTube) you acknowledge and provide us the rights to publish, claim against piracy, and monetize your library on such platforms and pay you for doing so in accordance to the revenue shares in section 3 as promotional royalties. You agree that the company withholds the right to not perform this service at any time.",
    doc.internal.pageSize.getWidth() / 15,
    258,
    { maxWidth: 180 }
  );

  doc.addPage();

  doc.text(
    "3. The ability to sub-license the content internally or externally to third-party publishing partners for the purpose of monetization and content protection benefit for you.",
    doc.internal.pageSize.getWidth() / 15,
    25,
    { maxWidth: 180 }
  );

  doc.text(
    "4. The ability to create an anchor account, or first account, on platforms where your presence is not currently established in order to prevent pirates from wrongfully uploading your catalog and claiming first rights. The revenue share for this is outlined as a promotional royalty in section 3.1. Royalties will continue to be paid to us from anchor accounts post-termination, and a buyout offer will be made to you for sole ownership, typically at a multiple of twelve the gross ARR we have generated on your behalf.",
    doc.internal.pageSize.getWidth() / 15,
    41,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 6. Ownership/Clearances/Warranties
  doc.text(
    "6. Ownership/Clearances/Warranties",
    doc.internal.pageSize.getWidth() / 15, 77
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1. You retain full ownership of your Content.",
    doc.internal.pageSize.getWidth() / 15,
    88,
    { maxWidth: 180 }
  );

  doc.text(
    "2. You must have all the necessary rights and clearances in connection with the Content, and you have the legal right to grant the rights to us. By registering, digi-signing, and submitting your Content and rights to CreatorShield FZCO, you hereby absorb all legal liability in the event of legal proceedings relating to the Content you submitted for management.",
    doc.internal.pageSize.getWidth() / 15,
    98,
    { maxWidth: 180 }
  );

  doc.text(
    "3. You warrant and represent that the Content does not infringe on the rights of any third party or violate third-party platform, including YouTube’s, Terms of Use. Additionally, you agree to defend, indemnify and hold harmless CreatorShield FZCO for any and all claims to the contrary",
    doc.internal.pageSize.getWidth() / 15,
    123,
    { maxWidth: 180 }
  );

  doc.setFontSize(12);
  doc.setFont("Helvetica", "bold");

  // 7. Other Provisions
  doc.text(
    "7. Other Provisions",
    doc.internal.pageSize.getWidth() / 15, 143
  );

  doc.setFont("Helvetica", "normal");
  doc.text(
    "1. You agree to keep the terms of this Agreement confidential.",
    doc.internal.pageSize.getWidth() / 15,
    153,
    { maxWidth: 180 }
  );

  doc.text(
    "2. This Agreement is governed and construed according to California law, and by signing, you are agreeing to submit to the jurisdiction of Los Angeles County, California.",
    doc.internal.pageSize.getWidth() / 15,
    163,
    { maxWidth: 180 }
  );

  doc.text(
    "3. You and CreatorShield FZCO waive all rights to a jury trial, instead electing that the dispute be resolved by a judge. Additionally, both parties agree that any and all disputes or claims that have arisen or may arise between either parties (CreatorShield FZCO and You, the 'Producer'), including federal and state, common law claims, and those based in contract, tort, fraud, misrepresentation or any other equitable or legal theory, and relating in any way to this website, its services or these will be resolved only by and through confidential final and binding arbitration, rather than in any court, except that You may only assert claims in small claims court if Your claims qualify and so long as the matter remains in such court and advances only on an individual (non-class, non-representative) basis.",
    doc.internal.pageSize.getWidth() / 15,
    178,
    { maxWidth: 180 }
  );

  doc.text(
    "4. Upon submission of acceptance of this User Agreement, I agree that all information in this form is true and accurate. I also agree that if I am under 18, my parent/guardian will sign this User Agreement and absorb all legal liability for this User Agreement.",
    doc.internal.pageSize.getWidth() / 15,
    228,
    { maxWidth: 180 }
  );

  doc.text(
    "5. You agree to, and are hereby bound to, our Terms of Service, found here, which may be amended from time to time. Continued use of our service is constituted as acceptance to such amendments. These terms include the exclusive, explicit, nontransferable content licensing rights to the content contractually submitted by you to CreatorShield FZCO. These rights remain even if you terminate this Agreement, in accordance to section 4 of this Agreement.",
    doc.internal.pageSize.getWidth() / 15,
    248,
    { maxWidth: 180 }
  );

  doc.addPage();

  doc.text(
    "6. Electronic communication is a sufficient method to notify a party.",
    doc.internal.pageSize.getWidth() / 15,
    25,
    { maxWidth: 180 }
  );

  doc.text(
    "7. By JOINING AND ACCEPTING OUR REGISTRATION FORMS, you agree as follows: 'I understand I am granting a non-transferable, irrevocable, fully exclusive license to all of the content submitted on the social media pages I am submitting, and that CreatorShield FZCO (CreatorShield FZCO, CreatorShield, and any other of its authorized divisions without limitation) may represent and manage this content on my behalf without limitation.'",
    doc.internal.pageSize.getWidth() / 15,
    35,
    { maxWidth: 180 }
  );

  doc.text(
    "Signee's Signature Information",
    doc.internal.pageSize.getWidth() / 15,
    70,
    { maxWidth: 180 }
  );

  doc.text(
    `Name: ${user.firstName} ${user.lastName}`,
    doc.internal.pageSize.getWidth() / 15,
    85,
    { maxWidth: 180 }
  );

  doc.text("Signature:", doc.internal.pageSize.getWidth() / 15, 95, {
    maxWidth: 180,
  });

  doc.addImage(signature, "PNG", 20, 107, 100, 20);

  doc.text(
    `via ${ipAddress} (${user.email})`,
    doc.internal.pageSize.getWidth() / 15,
    140,
    { maxWidth: 180 }
  );

  doc.setFontSize(14);
  highlightText(doc, `Acquired on ${currentDate} ${currentTime}`, 51, 150);

  doc.setFontSize(13);
  doc.text(
    "Content Submitted by the Producer for Irrevocable, NonTransferable, Exclusive Licensing to CreatorShield (and its authorized technology partners: Payfinity, Enfinity) was originally found at:",
    doc.internal.pageSize.getWidth() / 15,
    170,
    { maxWidth: 180 }
  );

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(12);
  doc.text(`•  ${user.socials.youtube}`, 30, 190);
  doc.text(`•  ${user.socials.tiktok}`, 30, 198);
  doc.text(`•  ${user.socials.instagram}`, 30, 206);
  doc.text(`•  ${user.socials.facebook}`, 30, 214);
  doc.text(`•  ${user.socials.twitchTv}`, 30, 222);
  doc.text(`•  ${user.socials.douyin}`, 30, 230);
  doc.text(`•  ${user.socials.kuaishou}`, 30, 238);
  doc.text(`•  ${user.socials.rumble}`, 30, 246);
  doc.text(`•  ${user.socials.others}`, 30, 254);

  doc.addPage();

  doc.setFontSize(13);
  doc.setFont("Helvetica", "bold");
  doc.text(
    'CreatorShield Authorized Signee: Jake W. Jones, CEO',
    doc.internal.pageSize.getWidth() / 15,
    25
  );

  doc.addImage(ceoSignature, "PNG", 15, 35, 100, 18);

  const timestamp = new Date().toLocaleString("en-US", {
    dateStyle: "medium",
    timeStyle: "short",
  });

  doc.setFontSize(10);
  doc.setFont("Helvetica", "normal");
  doc.text(`Signed on: ${timestamp}`, 22, 65);

  const pdfBlob = doc.output("blob");
  const file = new File(
    [pdfBlob],
    `CreatorShield_MCN_+_more_${user.firstName}_${user.lastName}_${user.email}.pdf`,
    {
      type: "application/pdf",
    }
  );

  // const pdfUrl = URL.createObjectURL(pdfBlob);
  // window.open(pdfUrl);
  // doc.save('CreatorShield-Terms-Of-Agreement');

  return file;
};
